import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { CANAL_DETALHE_DESIGN as D } from '../CanaisDetails.design';
import { MessageEditor } from '../CanaisFormParts';

// ----------------------------------------------------------------------

export default function ChannelDirect({
    canal,
    onChange,
    onChangeAutocomplete,
    listSectors,
    listUsers,
    // Campo renderizado como primeira coluna da grade de topo. O CanaisConfig
    // passa o seletor de estratégia para que "Distribuição" e "Status inicial"
    // sejam lidos na mesma linha, como no design.
    leadingField,
}) {
    const { t } = useTranslation('settings');

    const usuarios = React.useMemo(
        () =>
            canal?.config?.direcionamento_direto?.direciona_usuario
                ?.map((id) => listUsers?.find((usuario) => usuario._id === id))
                ?.filter((u) => u !== undefined) || [],
        [canal?.config?.direcionamento_direto?.direciona_usuario, listUsers]
    );

    const setores = React.useMemo(
        () =>
            canal?.config?.direcionamento_direto?.direciona_setor
                ?.map((id) => listSectors?.find((setor) => setor._id === id))
                ?.filter((s) => s !== undefined) || [],
        [canal?.config?.direcionamento_direto?.direciona_setor, listSectors]
    );

    const usersFormatted =
        listUsers?.map((user) => ({
            value: user._id,
            label: `${user.nomeFantasia} - ${user.nome_setor}`,
        })) || [];

    const sectorsFormatted =
        listSectors?.map((sector) => ({
            value: sector._id,
            label: sector.nome_setor,
        })) || [];

    const usuariosIds = React.useMemo(() => usuarios?.map((u) => u?._id) || [], [usuarios]);
    const setoresIds = React.useMemo(() => setores?.map((s) => s?._id) || [], [setores]);

    return (
        <div className="flex flex-col gap-6">
            <div className={D.grid2}>
                {leadingField}
                <div className={D.field}>
                    <label className={D.label}>{t('channels.direct.statusLabelFull', 'Status inicial da conversa')}</label>
                    <Select
                        value={canal?.config?.direcionamento_direto?.statusRoom || ''}
                        onValueChange={(value) => onChange({ target: { name: 'statusRoomDirectTarget', value } })}
                    >
                        <SelectTrigger className={D.select}>
                            <SelectValue placeholder={t('channels.direct.statusPlaceholder', 'Selecione o status')} />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="Atendendo">{t('channels.direct.statusAttending', 'Atendendo')}</SelectItem>
                            <SelectItem value="Pendente">{t('channels.direct.statusPending', 'Pendente')}</SelectItem>
                        </SelectContent>
                    </Select>
                    <p className={D.hint}>{t('channels.direct.statusHint', 'Como ela aparece na caixa de entrada.')}</p>
                </div>
            </div>

            <div className={D.divider} />

            <div className={D.grid2}>
                <div className={D.field}>
                    <label className={D.label}>{t('channels.direct.targetUsersLabelFull', 'Direcionar para usuários')}</label>
                    <MultiSelect
                        key={`users-${usuariosIds.join('-')}`}
                        options={usersFormatted}
                        defaultValue={usuariosIds}
                        className={D.multiSelect}
                        onValueChange={(value) =>
                            onChangeAutocomplete(null, value.map((v) => listUsers.find((u) => u._id === v)), 'directTargetUser')
                        }
                        placeholder={t('channels.direct.selectUsersPlaceholder', 'Selecionar usuários')}
                    />
                </div>

                <div className={D.field}>
                    <label className={D.label}>{t('channels.direct.targetSectorsLabelFull', 'Direcionar para setores')}</label>
                    <MultiSelect
                        key={`sectors-${setoresIds.join('-')}`}
                        options={sectorsFormatted}
                        defaultValue={setoresIds}
                        className={D.multiSelect}
                        onValueChange={(value) =>
                            onChangeAutocomplete(null, value.map((v) => listSectors.find((s) => s._id === v)), 'directTargetSector')
                        }
                        placeholder={t('channels.direct.selectSectorsPlaceholder', 'Selecionar setores')}
                    />
                </div>
            </div>

            <div className={D.divider} />

            <MessageEditor
                label={t('channels.direct.messageAfterTargetLabelFull', 'Mensagem após o direcionamento')}
                value={canal?.config?.direcionamento_direto?.mensagem_apos_cadastro}
                onChange={(value) => onChange({ target: { name: 'directTargetMessage', value } })}
                previewFoot={t('channels.direct.previewFoot', 'enviado automaticamente')}
            />
        </div>
    );
}
